import table from './VueTable.vue';
import dialog from './VueDialog.vue';
import pagination from './VuePagination.vue';
import Statistics from './Statistics.vue';

const globalComponents = {
  install: function (Vue) {
    Vue.component('VueTable', table);
    Vue.component('VueDialog', dialog);
    Vue.component('VuePagination', pagination);
    Vue.component('Statistics', Statistics);
  }
};

export default globalComponents;
